import ReplayIcon from '@mui/icons-material/Replay';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';

import React from 'react';
type props = {
  input: string;
  setInput: React.Dispatch<React.SetStateAction<string>>;
};
const ChatErrorMessage: React.FC<props> = ({ input, setInput }) => {
  const { t } = useTranslation(['chat']);
  const handleRetryInput = () => {
    setInput(input);
  };
  return (
    <Box
      data-testid="chat-error-message"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        my: 2,
        p: 3,
        border: '1px solid #ff000033',
        borderRadius: '12px',
        backgroundColor: '#ff00000a',
      }}
    >
      <Typography
        data-testid="chat-error-title"
        color="error"
        sx={{
          textAlign: 'left',
          fontWeight: 500,
        }}
      >
        {t('chatErrorMessage')}
      </Typography>
      <Box
        data-testid="chat-error-details"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 1,
          color: 'text.secondary',
        }}
      >
        <Typography sx={{ textAlign: 'left' }}>
          {t('chatErrorMessage2')}
        </Typography>
        <Typography sx={{ textAlign: 'left' }}>
          <span style={{ fontWeight: 600 }}>{t('chatErrorPhone')}</span>
          {t('ChatErrorPhoneNumber')}
        </Typography>

        <Typography sx={{ textAlign: 'left' }}>
          <span style={{ fontWeight: 600 }}>{t('chatErrorFrame')}</span>
          <Link
            href={
              'https://protect.checkpoint.com/v2/r01/___https://exp.world/expertcare___.YzJ1OmV4cHJlYWx0eTpjOmc6OGRlOGJlM2U1NGQwNzMyYzE5ZmI1Y2U5NzgyNGVkM2Y6Nzo1NzUwOmU0NDNjYjNlNWE5MmUwMGU3MGEwMGIwYzc4YmRlMjNiYjUyZGI3NmIzODg2MjZiNzk5ZWMxNTVlM2ZhM2QwNDg6dDpUOk4'
            }
            sx={{
              textDecoration: 'underline',
              color: 'text.secondary',
            }}
            target="_blank"
            rel="noopener noreferrer"
          >
            {t('chatErrorLinkText')}
          </Link>
        </Typography>

        <Typography sx={{ textAlign: 'left' }}>
          <span style={{ fontWeight: 600 }}>{t('chatErrorHours')}</span>
          {t('chatErrorHoursDesc')}
        </Typography>
      </Box>
      <Button
        data-testid="chat-error-retry-button"
        onClick={handleRetryInput}
        variant="outlined"
        sx={{
          alignSelf: 'flex-start',
          mt: 1,
          borderRadius: '8px',
          textTransform: 'none',
          boxShadow: 2,
          '&:hover': {
            boxShadow: 3,
          },
        }}
      >
        <ReplayIcon /> {t('errorButtonText')}
      </Button>
    </Box>
  );
};

export default ChatErrorMessage;
